import { useMemo } from 'react'
import { ButtonLink } from '@which/seatbelt'

import type { Category } from '../Configs/categories'
import styles from './ShowAlternativesButton.module.scss'

type ShowAlternativesButtonProps = {
  filters: Record<string, { [code: string]: string[] }>
  categorySlug: Category
  [key: `data-${string}`]: string | undefined
}

export const ShowAlternativesButton = ({
  filters,
  categorySlug,
  ...rest
}: ShowAlternativesButtonProps) => {
  const link = useMemo(() => {
    const urlSearchParams = new URLSearchParams()

    Object.entries(filters).forEach(([filterCategory, filterValues]) => {
      Object.entries(filterValues).forEach(([filterCode, filterValue]) => {
        filterValue.forEach((value) => {
          urlSearchParams.append(`filters.${filterCategory}.${filterCode}`, value)
        })
      })
    })

    const queryString = urlSearchParams.toString()

    return `/reviews/${categorySlug}${queryString ? `?${queryString}` : ''}`
  }, [filters, categorySlug])

  const buttonText = 'Show me alternatives'

  return (
    <ButtonLink
      href={link}
      appearance="secondary"
      className={styles.showAlternativesButton}
      data-action-group="onward journey"
      data-item-text={buttonText}
      {...rest}
    >
      {buttonText}
    </ButtonLink>
  )
}
